<template lang="html">

  <section class="wrapper">
    
    <template v-if="!!cv">
      <informacion-personal :noedit="isEmpresa" :cvdata="cv.personales" :imgperfil="cv.urlImagenPerfil"></informacion-personal>
      <datos-interes :noedit="isEmpresa" :cvinteres="cv.interes" :cvpersonales="cv.personales" ></datos-interes>
      <datos-academicos :cvacademicos="cv.academicos" :cvotrosestudios="cv.otra_formacion"></datos-academicos>
      <documentacion :noedit="isEmpresa" :cvdata="cv.documentos"></documentacion>
      <datos-profesionales :noedit="isEmpresa" :cvprofesionales="cv.profesional"></datos-profesionales>
      <idiomas :noedit="isEmpresa" :cvdata="cv.idiomas"></idiomas>
      <programas-informaticos :noedit="isEmpresa" :cvdata="cv.programasInformaticos"></programas-informaticos>
    </template>

    <div class="view-loading" v-else></div>
    
  </section>

</template>

<script lang="js">

  import informacionpersonal from '@/components/view-parts/espacio-personal/informacion-personal';
  import datosinteres from '@/components/view-parts/espacio-personal/datos-interes';
  import datosacademicos from '@/components/view-parts/espacio-personal/datos-academicos';
  import datosprofesionales from '@/components/view-parts/espacio-personal/datos-profesionales';
  import documentacion from '@/components/view-parts/espacio-personal/documentacion';
  import idiomas from '@/components/view-parts/espacio-personal/idiomas';
  import programasinformaticos from '@/components/view-parts/espacio-personal/programas-informaticos';

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'espacio-personal',
    mounted(){
      setTimeout(e => {
        if(this.isEmpresa & !!this.$route.params.id){
          this.removeCV()
          this.requestCandidato(this.$route.params.id);
        }
      },100)
    },
    components: {
      'informacion-personal': informacionpersonal,
      'datos-interes': datosinteres,
      'datos-academicos': datosacademicos,
      'datos-profesionales': datosprofesionales,
      'documentacion': documentacion,
      'idiomas': idiomas,
      'programas-informaticos': programasinformaticos,
    },
    computed : {
      ...mapGetters({
        cv : 'getCV',
        isEmpresa : 'isEmpresa'
      })
    },
    methods : {
      ...mapActions(['requestCandidato','removeCV'])
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/cv.vue